import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cozy%20minimalist%20interior%20scene%20with%20a%20fluffy%20orange%20tabby%20cat%20sleeping%20on%20a%20soft%20cream%20cushion%2C%20gentle%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20peaceful%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20artistic%20photography&width=1600&height=900&seq=hero-cat-community&orientation=landscape"
        alt="猫咪社区 - 爱猫人的温暖聚集地"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>
      <div className="relative z-10 w-full max-w-[800px] mx-auto px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
          {t("hero_title")}
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-3 font-light">
          {t("hero_subtitle")}
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-[600px] mx-auto mb-8 leading-relaxed">
          {t("hero_description")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/yanghu"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            {t("hero_cta")}
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white rounded-full font-medium text-sm hover:bg-white/25 transition-all duration-300 border border-white/20 whitespace-nowrap"
          >
            {t("join_community")}
          </Link>
        </div>
      </div>
    </section>
  );
}